import type { ContextState } from './context/types';
import type { EntitiesState } from './entities/types';
import type { State } from './types';
import type { UiState } from './ui/types';

export const contextSelector: (arg1: State) => ContextState = (state) => state.context;
export const entitiesSelector: (arg1: State) => EntitiesState = (state) => state.entities;
export const uiSelector: (arg1: State) => UiState = (state) => state.ui;
